import React from "react";

export function BDSectionCard({ title, points }) {
  return (
    <div className="bd-section-card mb-4">
      <div className="bd-section-card-header">
        <span className="bd-section-card-title">{title}</span>
      </div>
      <ul className="bd-section-card-list">
        {points.map((point, idx) => (
          <li key={idx}>
            {typeof point === 'string' ? point.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') : point}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function BDSectionColumn({ column, className }) {
  return (
    <div className={`col-md-6 mb-4 ${className || ''}`}>
      <div className="bd-section-column-title text-center mb-5">{column.title}</div>
      {column.items.map((item, idx) => (
        <BDSectionCard key={idx} title={item.title} points={item.points} />
      ))}
    </div>
  );
}